/**
 * @generated SignedSource<<a4f8c9d58a6faf25e6c4cba3e3521c80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
export type OrganizationContextInput = {
  clientMutationId?: string | null;
  cloudId?: string | null;
  orgId?: string | null;
};
export type BootstrapGoalsQuery$variables = {
  context?: OrganizationContextInput | null;
};
export type BootstrapGoalsQuery$data = {
  readonly bootstrap: {
    readonly cloudIds: ReadonlyArray<string> | null;
    readonly collabContext: {
      readonly cloudIds: ReadonlyArray<string>;
      readonly hasMultipleUnits: boolean;
      readonly isMultiSite: boolean;
    } | null;
    readonly orgId: string;
    readonly userIsOrgAdmin: boolean;
    readonly workspaces: ReadonlyArray<{
      readonly cloudId: string;
      readonly id: string;
      readonly type: WorkspaceType;
      readonly uuid: string;
      readonly " $fragmentSpreads": FragmentRefs<"CapabilityRouterFragment" | "storeHomeWorkspace" | "utils_checkUserHasCapabilities">;
    } | null> | null;
  } | null;
};
export type BootstrapGoalsQuery = {
  response: BootstrapGoalsQuery$data;
  variables: BootstrapGoalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "organizationContext",
    "variableName": "context"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v3 = {
  "kind": "ScalarField",
  "name": "cloudIds"
},
v4 = {
  "concreteType": "CollabContextBootstrap",
  "kind": "LinkedField",
  "name": "collabContext",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "name": "isMultiSite"
    },
    {
      "kind": "ScalarField",
      "name": "hasMultipleUnits"
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "name": "userIsOrgAdmin"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v8 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "keyPrefix"
},
v12 = {
  "kind": "ScalarField",
  "name": "timezone"
},
v13 = {
  "kind": "ScalarField",
  "name": "goalScoringMode"
},
v14 = {
  "kind": "ScalarField",
  "name": "activationId"
},
v15 = {
  "kind": "ScalarField",
  "name": "capability"
},
v16 = {
  "kind": "ScalarField",
  "name": "capabilityContainer"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BootstrapGoalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AtlassianHomeBootstrap",
        "kind": "LinkedField",
        "name": "bootstrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "WorkspaceSummary",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "kind": "InlineDataFragmentSpread",
                "name": "storeHomeWorkspace",
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v8/*: any*/),
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v14/*: any*/)
                ],
                "argumentDefinitions": []
              },
              {
                "kind": "FragmentSpread",
                "name": "CapabilityRouterFragment"
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "utils_checkUserHasCapabilities",
                "selections": [
                  {
                    "concreteType": "UserCapabilities",
                    "kind": "LinkedField",
                    "name": "userCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Capability",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": true,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "argumentDefinitions": []
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BootstrapGoalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AtlassianHomeBootstrap",
        "kind": "LinkedField",
        "name": "bootstrap",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "WorkspaceSummary",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "concreteType": "UserCapabilities",
                "kind": "LinkedField",
                "name": "userCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Capability",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ccbade2af814e3e314f9044122c77be4",
    "id": null,
    "metadata": {},
    "name": "BootstrapGoalsQuery",
    "operationKind": "query",
    "text": "query BootstrapGoalsQuery(\n  $context: OrganizationContextInput\n) {\n  bootstrap(organizationContext: $context) {\n    orgId\n    cloudIds\n    collabContext {\n      cloudIds\n      isMultiSite\n      hasMultipleUnits\n    }\n    userIsOrgAdmin\n    workspaces {\n      id\n      uuid\n      cloudId\n      type\n      ...storeHomeWorkspace\n      ...CapabilityRouterFragment\n      ...utils_checkUserHasCapabilities\n    }\n  }\n}\n\nfragment CapabilityRouterFragment on WorkspaceSummary {\n  userCapabilities {\n    capabilities {\n      capability\n      capabilityContainer\n      id\n    }\n  }\n}\n\nfragment storeHomeWorkspace on WorkspaceSummary {\n  id\n  uuid\n  name\n  keyPrefix\n  timezone\n  cloudId\n  goalScoringMode\n  type\n  activationId\n}\n\nfragment utils_checkUserHasCapabilities on WorkspaceSummary {\n  userCapabilities {\n    capabilities {\n      capability\n      capabilityContainer\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f32422fe09e322a1e1cd031f33f2adf";

export default node;
